




























































import {
  defineComponent, reactive, ref, Ref, computed,
} from '@vue/composition-api';

import ServerAndClient from './ServerAndClient.vue';

const FANCAM_POC_INSTANCE_KEY = process.env.VUE_APP_FANCAM_POC_INSTANCE_KEY || 'LiveRtcTest';

const Index = defineComponent({
  components: {
    ServerAndClient,
  },
  setup() {
    const roomID: Ref<string | number> = ref('');
    const roomIDTemp: Ref<string | number> = ref(FANCAM_POC_INSTANCE_KEY);

    const greenscreenLink = computed(() => `${window.location.protocol}//${window.location.host}/#/live-helpers/fan-cam-greenscreen/${roomID.value}-backend`);

    const stateGreenscreen = ref('READY');
    const metrics = reactive({
      inbound: 0,
      outbound: 0,
    });

    const config = reactive({
      freeflowWidth: 320,
    });

    return {
      config,
      stateGreenscreen,
      metrics,
      roomID,
      roomIDTemp,
      greenscreenLink,
    };
  },
});

export default Index;
